export default __webpack_public_path__ + "static/media/PushNotif.b48f2396.svg";